/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Technical_Specifications_HelpInputs */

const en_technical_specifications_help = /** @type {(inputs: Technical_Specifications_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technical specifications help the Quiet Intelligence engine answer buyer questions accurately.`)
};

const es_technical_specifications_help = /** @type {(inputs: Technical_Specifications_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las especificaciones técnicas ayudan al motor de Inteligencia Silenciosa a responder preguntas de los compradores con precisión.`)
};

const fr_technical_specifications_help = /** @type {(inputs: Technical_Specifications_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les spécifications techniques aident le moteur d'Intelligence Silencieuse à répondre avec précision aux questions des acheteurs.`)
};

const de_technical_specifications_help = /** @type {(inputs: Technical_Specifications_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technische Spezifikationen helfen der Quiet Intelligence-Engine, Käuferfragen genau zu beantworten.`)
};

const ja_technical_specifications_help = /** @type {(inputs: Technical_Specifications_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術仕様は、静かなインテリジェンスエンジンが購入者の質問に正確に答えるのに役立ちます。`)
};

const zh_technical_specifications_help = /** @type {(inputs: Technical_Specifications_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技术规格有助于隐形智能引擎准确回答买家的问题。`)
};

const ar_technical_specifications_help = /** @type {(inputs: Technical_Specifications_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تساعد المواصفات الفنية محرك الذكاء الهادئ في الإجابة على أسئلة المشترين بدقة.`)
};

const id_technical_specifications_help = /** @type {(inputs: Technical_Specifications_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spesifikasi teknis membantu mesin Kecerdasan Senyap menjawab pertanyaan pembeli secara akurat.`)
};

const it_technical_specifications_help = /** @type {(inputs: Technical_Specifications_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le specifiche tecniche aiutano il motore di Intelligenza Silenziosa a rispondere in modo accurato alle domande degli acquirenti.`)
};

const ru_technical_specifications_help = /** @type {(inputs: Technical_Specifications_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технические характеристики помогают механизму искусственного интеллекта точно отвечать на вопросы покупателей.`)
};

const pt_technical_specifications_help = /** @type {(inputs: Technical_Specifications_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As especificações técnicas ajudam o mecanismo de Inteligência Silenciosa a responder perguntas dos compradores com precisão.`)
};

const ko_technical_specifications_help = /** @type {(inputs: Technical_Specifications_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기술 사양은 조용한 인텔리전스(Quiet Intelligence) 엔진이 구매자의 질문에 정확하게 답변하는 데 도움이 됩니다.`)
};

/**
* | output |
* | --- |
* | "Technical specifications help the Quiet Intelligence engine answer buyer questions accurately." |
*
* @param {Technical_Specifications_HelpInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const technical_specifications_help = /** @type {((inputs?: Technical_Specifications_HelpInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technical_Specifications_HelpInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_technical_specifications_help(inputs)
	if (locale === "es") return es_technical_specifications_help(inputs)
	if (locale === "fr") return fr_technical_specifications_help(inputs)
	if (locale === "de") return de_technical_specifications_help(inputs)
	if (locale === "ja") return ja_technical_specifications_help(inputs)
	if (locale === "zh") return zh_technical_specifications_help(inputs)
	if (locale === "ar") return ar_technical_specifications_help(inputs)
	if (locale === "id") return id_technical_specifications_help(inputs)
	if (locale === "it") return it_technical_specifications_help(inputs)
	if (locale === "ru") return ru_technical_specifications_help(inputs)
	if (locale === "pt") return pt_technical_specifications_help(inputs)
	return ko_technical_specifications_help(inputs)
});